// Models offered in Print Preview's "How do I find my printer's IP?" popup.
//
// `guide` picks the step list in locales/*/printPreview.json → ipHelp.guides.<guide>.
// Each guide follows HP's own user guide for that front panel (owner-supplied
// PDFs, 2026-09-30, "tech support/<model> - network.pdf"):
//   t200t600 — HP DesignJet T200/T600 series user guide (T600 - network.pdf)
//   t800     — T850/T950 and T870 user guides (identical control-panel paths)
//   z6       — Z6 / Z9⁺ user guide (Z6 - network.pdf)
// A model with no guide shows ipHelp.guides.default. Canon TM is left out for now.
export const IP_HELP_GROUPS = [
  { label: 'print.iphelp.groups.t200t600', models: [
    { id: 'T210', label: 'T210', guide: 't200t600' },
    { id: 'T230', label: 'T230', guide: 't200t600' },
    { id: 'T250', label: 'T250', guide: 't200t600' },
    { id: 'T630', label: 'T630', guide: 't200t600' },
    { id: 'T650', label: 'T650', guide: 't200t600' },
  ] },
  { label: 'print.iphelp.groups.t500', models: [
    { id: 'T520', label: 'T520', guide: 'default' },
    { id: 'T530', label: 'T530', guide: 'default' },
  ] },
  { label: 'print.iphelp.groups.t800', models: [
    { id: 'T850', label: 'T850', guide: 't800' },
    { id: 'T870', label: 'T870', guide: 't800' },
    { id: 'XT870', label: 'XT870', guide: 't800' },
    { id: 'T950', label: 'T950', guide: 't800' },
  ] },
  { label: 'print.iphelp.groups.z', models: [
    { id: 'Z6', label: 'Z6', guide: 'z6' },
    { id: 'Z9', label: 'Z9⁺', guide: 'z6' },
  ] },
];

export const IP_HELP_MODELS = IP_HELP_GROUPS.flatMap(g => g.models);

// Step text (desktop locales/en/printPreview.json ipHelp.guides, copied 2026-10-16).
// [menu] [info] [settings] [network] [wifi] [search] render as icon chips; *x* as bold.
// Step text lives in locales/<lang>/bv.json → print.iphelp.guides.<guide> (steps[], alt?, source?).
export const IP_HELP_GUIDE_KEYS = ['t200t600', 't800', 'z6', 'default'];
export const IP_HELP_GUIDES = Object.fromEntries(IP_HELP_GUIDE_KEYS.map((k) => [k, k]));
